<template>
	<div v-if="loadingCategories || loadingCareers">
		<div class="loading">
			<Loader />
		</div>
	</div>
	<div v-else>
		<template v-if="!selectedCategory">
			<div class="">
				<div class="container">
					<div class="skillset">
						<h3 class="section__title">Select A Career Category</h3>
						<div>
							<form action="">
								<div class="form-group">
									<label for="category">Select category</label>
									<select 
										v-model="selectedCategory"
										class="custom-select form__select" 
										id="category">
										<option selected value="">Select Career Category</option>
										<template v-if="categoriesLoaded && categories.length">
											<option 
												v-for="category in categories" 		
												:value="category.id" 	
												:key="category.id">
												{{	category.name }}
											</option>
										</template>
										<template v-else>
											<option>Error loading categories</option>
										</template>
									</select>
								</div>
							</form>
						</div>
					</div>
				</div>
			</div>
		</template>
		<template v-else>
			<template v-if="!selectedCareerSegment">
				<div class="">
					<div class="container">
						<div class="skillset">
							<h3 class="section__title">Select A Career Segment</h3>
							<div>
								<form action="">
									<div class="form-group">
										<label for="category">Select segment</label>
										<select 
											v-model="selectedCareerSegment"
											class="custom-select form__select" 
											id="category">
											<option selected value="">Select Career Segment</option>
											<template v-if="careerSegmentLoaded && careerSegment.length">
												<option 
													v-for="item in careerSegment" 		
													:value="item.id" 	
													:key="item.id">
													{{	item.name }}
												</option>
											</template>
											<template v-else>
												<option>Error loading career segments</option>
											</template>
										</select>
									</div>
								</form>
							</div>
						</div>
					</div>
				</div>
			</template>
			<template v-else>
				<div>
					<div class="container">
						<div class="skillset">
							<div class="">
								<h3 class="section__title">Select A Career Path</h3>
								<ul class="skillset__grid">
									<li 
										v-for="career in careers"
										:Key="career.id" 
										class="panel__item">{{ career.name }}
										<label class="check">
											<input 
												type="radio"
												:value="career.id"
												v-model="selectedCareer">
											<span class="checkmark"></span>
										</label>
									</li>
								</ul>
								<div class="btn__group btn__group--flex">
									<button 
										class="btn__primary btn__main"
										@click="saveCareers">Save</button>
								</div>
							</div>
						</div>
					</div>
				</div>
			</template>
		</template>
	</div>
</template>

<script>
import { mapGetters, mapMutations } from 'vuex';
import { selectCareer, getAllCategories } from '../utils/api/careers';
import Loader from '../components/Loader';
import { success, fail } from '../utils/toast';

export default {
	name: 'Careers',
	data() {
		return {
			selectedCareer: null,
			careers: {},
			loadingCareers: false,
			careersLoaded: false,
			selectedCategory: '',
			categories: [],
			categoriesLoaded: false,
			loadingCategories: true,
			selectedCategories: [],
			careerSegment: [],
			careerSegmentLoaded: false,
			loadingCareerSegment: true,
			selectedCareerSegment: ''
	
		};
	},
	watch: {
		selectedCategory(val) {
			this.getCareerSegment(val);
		},
		selectedCareerSegment(val) {
			this.getSelectedCareers(val);
		}
	},
	mounted() {
		if (this.userObject.is_credential_uploaded !== 1) {
			success({
				title: 'Notice!',
				text: 'Kindly update your credentials to proceed, you are being redirected.',
				timer: 8000
			});
			setTimeout(() => {
				this.$router.push({ name: 'user-profile', params: { id: this.$session.get('id') } });
			}, 5000);
		} else if (this.userObject.is_psychometric_completed !== 1) {
			success({
				title: 'Notice!',
				text: 'Kindly complete your psychometirc tests to continue, you are being redirected.', 
				timer: 8000
			});
			setTimeout(() => {
				this.$router.push({ name: 'test' });
			}, 5000);
		} else if (this.userObject.is_career_selected === 1) {
			fail({
				title: 'Notice!',
				text: 'You have already selected a career choice',
				timer: 8000
			});
			setTimeout(() => {
				this.$router.push({ name: 'dashboard' });
			}, 50);
		}
	},
	created() {
		this.getCategories();
	},
	computed: {
		...mapGetters([
			'userObject'
		])
	},
	methods: {
		...mapMutations([
			'updateUserObject'
		]),
		saveCareers() {
			selectCareer(
				this.$session.get('id'),
				{
					career_id: this.selectedCareer
				}
			)
				.then((response) => {
					if (response.status === 201) {
						success({
							title: 'Success! You have shosen a career track.'
						});

						const careerResult = {
							career: {
								career_id: this.selectedCareer
							}
						};
						this.updateUserObject({ is_career_selected: 1 });
						this.updateUserObject(careerResult);
						this.$router.push('/dashboard');
						return true;
					}
					return false;
				})
				.catch((error) => {
					fail({
						title: 'Oops! Something went wrong',
						text: error.data
					});
					return error;
				});
			return true;
		},
		getCategories() {
			getAllCategories()
				.then((response) => {
					if (response.status === 200) {
						this.categories = response.data.data;
						this.categoriesLoaded = true;
						return true;
					}
					this.categoriesLoaded = false;
					return false;
				})
				.catch((error) => {
					this.categoriesLoaded = false;
					return error;
				})
				.finally(() => {
					this.loadingCategories = false;
				});
			return true;
		},
		getSelectedCareers(id) {
			this.careerSegment.forEach((item) => {
				if (item.id === id) {
					this.careers = item.careers;
					this.careersLoaded = true;
					this.loadingCareers = false;
					return true;
				}
				this.loadingCareers = false;
				return false;
			});
			return true;
		},
		getCareerSegment(id) {
			this.categories.forEach((item) => {
				if (item.id === id) {
					this.careerSegment = item.segments;
					this.careerSegmentLoaded = true;
					this.loadingCareerSegment = false;
					return true;
				}
				this.loadingCareerSegment = false;
				return false;
			});
			return true;
		}
	},
	components: {
		Loader
	}
};
</script>

<style lang="scss" scoped>
.loading {
	display: flex;
    justify-content: center;
    align-items: center;
    height: 100vh;
}
</style>
